import jstz from 'jstz';

export default function currentTimeZone() {
  return jstz.determine().name();
}
